// import React from 'react';
// import { Link } from 'react-router-dom';
import "./style.css";
// Import images
import AboutImg from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM (2).jpeg";

const WhoWeAre = () => {
  return (
    <section className="who_we_are_section section_padding">
      <div className="container">
        <div className="row align-items-center who-we-are-row">
          <div className="col-lg-4 col-md-12 who_we_are_img_col">
            <div className="who_we_are_img">
              <img
                src={AboutImg}
                alt="Cradle Care Foundation"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 who_we_are_text_col">
            <div className="who_we_are_content">
              <h2 className="who_we_are_heading">Who We Are</h2>
              <div className="who_we_are_subheading">
                Bringing Light & Love to Expectant Mothers
              </div>
              <p className="who_we_are_paragraph">
                Cradle Care Foundation is a Christ-centered nonprofit in
                Nigeria. We provide emotional, spiritual, educational, and
                material support to pregnant women whose lives have been
                impacted by unplanned pregnancy or financial hardship.
              </p>
              <p className="who_we_are_paragraph">
                We exist to bring light and love into what can feel like the
                darkest moments in an expectant mom’s life.
              </p>
              <p className="who_we_are_paragraph">
                Located in Nigeria, Cradle Care focuses on supporting pregnant
                women facing social, emotional, and economic challenges as a
                result of unplanned pregnancies. Whether abandoned, financially
                strained, or emotionally overwhelmed, every mother deserves a
                cradle of care—a safe space to be loved, supported, and
                uplifted.
              </p>
              <div className="who_we_are_stats_row">
                {/* {stats.map((stat, idx) => (
                                    <div className="who_we_are_stat" key={idx}>
                                        <span className="who_we_are_stat_icon" style={{ color: stat.color }}>
                                            <FontAwesomeIcon icon={stat.icon} />
                                        </span>
                                        <div className="who_we_are_stat_value">{stat.value}</div>
                                        <div className="who_we_are_stat_label">{stat.label}</div>
                                    </div>
                                ))} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
